import { Package, Activity, TrendingDown } from 'lucide-react'
import { ItemProcesses, ActivityLogs, DepreciationEditor } from '../Shared'

export const tabs = () => [
    {
        label: 'Linked Processes',
        value: 'processes',
        startIcon: <Package className="text-primary w-4 h-4" />,
        component: <ItemProcesses />,
    },
    {
        label: 'Activity Logs',
        value: 'logs',
        startIcon: <Activity className="text-primary w-4 h-4" />,
        component: <ActivityLogs entityType="component" />,
    },
    {
        label: 'Depreciation',
        value: 'depreciation',
        startIcon: <TrendingDown className="text-primary w-4 h-4" />,
        component: <DepreciationEditor />,
    },
]
